/* eslint-disable import/order */

import React, { type FC } from 'react';

import type { BadgeProps } from './Badge.types';

import styles from './Styles/Default.module.css';
import styleVariants from './Styles/Variant.module.css';

export const Badge: FC<BadgeProps> = React.forwardRef<HTMLElement, BadgeProps>(
  (
    { children, color = 'primary', leftIcon, dataTestId, Component = 'div', rounded, ...restProps },
    ref,
  ) => {
    return (
      <Component
        className={`${styleVariants[`badge_${color}`]} ${styles.badge} ${
          restProps.inline ? styles.inline : ''
        }`}
        data-test-id={dataTestId}
        data-rounded={rounded ? 'true' : 'false'}
        ref={ref}
        {...restProps}
      >
        {leftIcon && <span className={styles.leftIcon}>{leftIcon}</span>}
        {children}
      </Component>
    );
  },
);

Badge.displayName = 'Badge';

export default Badge;
